<template>
    <Card class="card">
        <template #header>
            <!-- <img alt="user header" src="demo/images/usercard.png"> -->
        </template>
        <template #title>
            {{ mode == "register" ? "Register" : "Profile" }}
        </template>
        <template #content>
            <div class="p-fluid formgrid grid">
                <!-- <div class="field col-12 md:col-6 input">
                    <label for="firstName">*First Name</label>
                    <InputText id="firstName" type="text" v-model="user.firstName" />
                </div>
                <div class="field col-12 md:col-6 input">
                    <label for="lastName">*Last Name</label>
                    <InputText id="lastName" type="text" v-model="user.lastName" />
                </div> -->
                <div class="field col-12 md:col-6 input">
                    <label for="username">*Username</label>
                    <InputText v-if="mode == 'register'" id="username" type="text" v-model="user.username" />
                    <div v-else>{{ user.username }}</div>
                    <small v-if="usernameExists" id="username-help" class="p-error">Username already exists.</small>
                    <small v-if="hasSpecialCharacters" class="p-error">Username
                        cannot contain any of the following characters: ! @ # $ % ^ & * ( ) [ ]
                        { } &lt; &gt; | \ = + ? , : ; ' "</small>
                </div>
                <div class="field col-12 md:col-6 input">
                </div>
                <div class="field col-12 md:col-6 input">
                    <label for="password">*Password</label>
                    <Password v-if="mode == 'register'" v-model="user.password" toggle-mask :feedback="false"
                        @blur="checkValidPassword" @input="checkValidPassword" />
                    <Password v-else v-model="password" toggle-mask :feedback="false" @blur="checkValidPassword"
                        @input="checkValidPassword" />
                    <small v-if="user.password || password" :class="[
                        'password-strength',
                        passwordStrength < 3 ? 'p-error' : passwordStrength < 5 ? 'p-warning' : 'p-success'
                    ]">
                        Password Strength:
                        <span v-if="passwordStrength < 3">Weak</span>
                        <span v-else-if="passwordStrength < 5">Medium</span>
                        <span v-else>Strong</span>
                    </small>
                    <small v-if="passwordNotValid" id="password-help" class="p-error">*Password must be at least 8
                        characters, contain letters and numbers, cannot contain username, and must be a medium or strong
                        password.</small>
                </div>
                <div class="field col-12 md:col-6 input">
                    <label for="confirmPassword">*Confirm Password</label>
                    <Password v-model="confirmPassword" :feedback="false" toggle-mask aria-describedby="password-help"
                        @blur="checkPassword" @input="checkPassword" />
                    <small v-if="passwordNotMatch" id="password-help" class="p-error">Password does not
                        match.</small>
                </div>
                <div class="field col-12 md:col-6 input">
                    <label for="company">*Company
                        <i class="pi pi-question-circle" style="padding-left:5px" v-tooltip.bottom="{
                            value: `For new company registration, kindly input your company fullname in this field.
                            Each company can have one account in Web-CNMP. Please coordinate within your company to assign a company administrator and register via this page. We will set up the account accordingly and send the login information via email. Once the admin account is activated, other users within your company can register and the company administrator will be responsible for the approving company user registration.
                            `,
                            escape: true
                        }">
                        </i></label>
                    <AutoComplete v-if="mode == 'register'" v-model="user.company" :suggestions="filteredCompanies"
                        @complete="searchCompany($event)" style="width:100%" dropdown
                        emptySearchMessage="Your company is not registered in web-cnmp yet. Please enter your company full name and you will become the company admin after EPD review your registration.">
                    </AutoComplete>
                    <div v-else>{{ user.company }}</div>
                </div>
                <div class="field col-12 md:col-6 input">
                    <label for="email">*Email</label>
                    <InputText id="email" type="text" v-model="user.email" aria-describedby="email-help"
                        @blur="checkEmail" />
                    <small v-if="emailInvalid || emailExists" id="email-help" class="p-error">
                        {{ emailInvalid ? "Email format is not correct." : "Email already exists." }}
                    </small>
                </div>
                <div class="field col-12 md:col-6 input">
                    <!-- <label for="phoneNumber">*Phone Number</label>
                    <InputMask id="phoneNumber" type="text" v-model="user.phone" mask="(+999)9999-9999"
                        placeholder="(+852)9999-9999" /> -->
                </div>
            </div>
        </template>
        <template #footer>
            <div class="footer-container">
                <small v-if="updateError" class="p-error update-error">{{ updateError }}</small>
                <div class="footer">
                    <Button label="Cancel" class="p-button-secondary" @click='cancelOnClick()' />
                    <Button :label="mode == 'register' ? 'Register' : 'Save'" @click='registerOnClick()'
                        :disabled="disabled() || loading == 'pi pi-spin pi-spinner'" :icon="loading" iconPos="right" />
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import CryptoHelper from '@/helper/CryptoHelper';
import zxcvbn from 'zxcvbn';
export default {
    name: 'Login',
    props: {
        hasAccount: Boolean,
        user: Object,
        title: String,
        buttonLabel: String,
        mode: String
    },
    data() {
        return {
            firstName: "",
            lastName: "",

            username: "",
            usernameExists: false,

            password: "",
            confirmPassword: "",
            passwordNotMatch: false,
            passwordNotValid: false,

            company: "",
            companies: ["Ka Shing Management Consultant LTD", "China Road and Bridge Corporation", "Vibro (H.K.) Limited", "Wilson Ho and Associates Limited", "CR CONSTRUCTION COMPANY LIMITED", "Lam Environmental Services Limited", "ERM-HK Limited", "WSP (Asia) Limited", "Shui On Construction Company Limited", "Shun Yuen Construction Company Limited", "FONG WING SHING CONSTRUCTION CO., LTD.", "Binnies Hong Kong Limited", "BeeXergy Consulting Limited", "Alchmex - Paul Y Joint Venture", "Great Harvest Group", "Ove Arup & Partners Hong Kong", "Kin Wing Engineering Company Limited", "Hip Hing Engineering Company Limited", "Leighton Contractors (Asia) Limited", "Build King Construction Limited", "Chevalier (Construction) Company Limited", "Chevalier Construction (Hong Kong) Limited", "Chevalier (Civil Engineering) Limited", "CPC Construction Hong Kong Limited", "Lam Woo & Company Limited", "Acoustics and Air Testing Laboratory Company Limited", "Mott MacDonald", "Meinhardt Infrastructure and Environment Ltd", "Westwood Hong & Associates Limited", "Shui On Construction Company Limited", "Sanfield (Management) Limited", "AECOM Asia Company Limited", "Ramboll Hong Kong Limited", "Tysan Foundation Limited", "Urban Green Consultants Limited"],
            filteredCompanies: null,

            email: "",
            emailInvalid: false,
            emailExists: false,

            phoneNumber: "",

            loading: "",

            passwordStrength: 0,
            updateError: ""
        }
    },
    mounted() {
        this.getExistingCompanies();
    },
    computed: {
        hasSpecialCharacters() {
            return /[ `!@#$%^&*()+=\[\]{};: \\|,<>\/?~\'\"]/.test(this.user.username);
        },
    },
    methods: {
        checkPassword() {
            if (this.mode == "register") {
                this.passwordNotMatch = this.user.password != this.confirmPassword;
            }
            else {
                this.passwordNotMatch = this.password != this.confirmPassword;
            }
        },
        checkValidPassword() {
            if (this.mode == "register") {
                const pwd = this.user.password || "";
                const username = this.user.username || "";
                const hasLetters = /[a-zA-Z]/.test(pwd);
                const hasNumbers = /[0-9]/.test(pwd);
                const doesNotContainUsername = !pwd.toLowerCase().includes(username.toLowerCase());
                this.passwordStrength = zxcvbn(pwd).score

                this.passwordNotValid = !(pwd.length >= 8 && hasLetters && hasNumbers && this.passwordStrength >= 3 && doesNotContainUsername);
            }
            else {
                const pwd = this.password || "";
                const username = this.user.username || "";
                const hasLetters = /[a-zA-Z]/.test(pwd);
                const hasNumbers = /[0-9]/.test(pwd);
                const doesNotContainUsername = !pwd.toLowerCase().includes(username.toLowerCase());
                this.passwordStrength = zxcvbn(pwd).score

                this.passwordNotValid = !(pwd.length >= 8 && hasLetters && hasNumbers && this.passwordStrength >= 3 && doesNotContainUsername);
            }
        },
        checkEmail() {
            let re = /^[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*(\.[a-zA-Z]{2,3})+$/;
            this.emailInvalid = !re.test(this.user.email);
        },
        registerOnClick() {
            let props = this;
            if (this.mode == "register") {
                this.isUsernameExist(function () {
                    props.register(function (user) {
                        props.$emit('registerOnClick', user.userType, true);
                        props.loading = "";
                    })
                });
            }
            else {
                this.updateUser();
            }
        },
        cancelOnClick() {
            this.$emit('cancelOnClick');
        },
        isUsernameExist(callback) {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}user?username=${this.user.username}`)
                .then(response => {
                    props.usernameExists = false;
                    // props.isEmailExist(callback);
                    callback();
                })
                .catch(error => { props.usernameExists = true; props.loading = ""; })
        },
        isEmailExist(callback) {
            let props = this;
            this.axios
                .get(`${this.apiEndpoint}user?email=${this.user.email}`)
                .then(response => { props.emailExists = false; callback(); })
                .catch(error => { props.emailExists = true; props.loading = ""; })
        },
        getExistingCompanies() {
            this.axios
                .get(`${this.apiEndpoint}user/companies`)
                .then(response => this.companies = [...new Set([...this.companies, ...response.data])])
        },
        searchCompany(event) {
            if (!event.query.trim().length) {
                this.filteredCompanies = [...this.companies].sort();
            }
            else {
                this.filteredCompanies = this.companies.filter((company) => {
                    return company.toLowerCase().includes(event.query.toLowerCase());
                }).sort();
            }
        },
        disabled() {
            if (this.mode == "register") {
                return !(this.user.password && this.confirmPassword && !this.passwordNotValid && !this.passwordNotMatch && this.user.company && this.user.email && !this.user.emailInvalid);
            }
            else {
                return !(!this.passwordNotValid && !this.passwordNotMatch && this.user.company && this.user.email && !this.user.emailInvalid);
            }
            // return false;
        },
        register(callback) {
            this.loading = "pi pi-spin pi-spinner";
            let data = {
                ...this.user,
                firstName: this.user.firstName.trim(),
                lastName: this.user.lastName.trim(),
                company: this.user.company.trim(),
                email: this.user.email.trim(),
                phone: this.user.phone.trim(),
                password: CryptoHelper.Encrypt(this.user.password),
                // password: ""
            }
            this.axios
                .post(`${this.apiEndpoint}user/register`, data)
                .then(function (response) {
                    callback(response.data);
                })
                .catch(error => console.log(error))
        },
        updateUser() {
            let props = this;
            this.loading = "pi pi-spin pi-spinner";
            this.updateError = "";
            let data = {
                ...this.user,
                password: this.password ? CryptoHelper.Encrypt(this.password, this.user.guid.replaceAll("-", "")) : this.user.password,
            }
            this.axios
                .post(`${this.apiEndpoint}user`, data)
                .then(function (response) {
                    localStorage.setItem("epd-cnmp-user", CryptoHelper.Encrypt(JSON.stringify(props.user)))
                    props.$store.dispatch('login', {
                        user: props.user
                    });
                    props.$router.replace({ path: '/' });
                })
                .catch(error => {
                    console.log(error);
                    props.loading = "";
                    props.updateError = error.response?.data || "Failed to update user profile. Please try again.";
                })
        }
    }
}
</script>

<style scoped>
.card {
    width: 30vw;
    min-width: 500px;
}

.footer-container {
    width: 100%;
}

.update-error {
    display: block;
    margin-bottom: 1rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.footer {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;
}

.input {
    text-align: left;
    font-size: 14px;
}

.p-button {
    width: 110px;
    flex-shrink: 0;
}

.password-strength {
    display: block;
    margin-top: 0.5rem;
    font-weight: 500;
}

.p-warning {
    color: #f59e0b;
}

.p-success {
    color: #10b981;
}
</style>